import api from './Api';

export interface PasswordResetRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface AdminResetPasswordRequest {
  userId: number;
  newPassword: string;
}

export const PasswordResetApi = {
  // Request password reset (sends email with reset link)
  requestPasswordReset: (emailOrUsername: string) => {
    return api.post('/auth/forgot-password', { emailOrUsername });
  },

  // Reset password using token from email
  resetPassword: (data: ResetPasswordRequest) => {
    return api.post('/auth/reset-password', data);
  },

  // Change password for logged-in user
  changePassword: (data: ChangePasswordRequest) => {
    return api.post('/auth/change-password', data);
  },

  // Admin reset password for any user
  adminResetPassword: (data: AdminResetPasswordRequest) => {
    return api.post('/auth/admin-reset-password', data);
  },

  // Check if password reset token is valid
  validateResetToken: (token: string) => {
    return api.get(`/auth/validate-token?token=${token}`);
  },

  // Force password reset on first login
  forcePasswordReset: (data: { username: string; currentPassword: string; newPassword: string }) => {
    return api.post('/auth/force-reset', data);
  }
};
